import { ReactComponent as HomeIcon } from '@app/assets/admin-icons/home_icon.svg';
import { ReactComponent as FishingOperationsIcon } from '@app/assets/admin-icons/fishingOperations_icon.svg';
import { ReactComponent as FishingManagementIcon } from '@app/assets/admin-icons/fishingManagement_icon.svg';
import { ReactComponent as FishingHabitatIcon } from '@app/assets/admin-icons/fishingHabitat_icon.svg';
import { ReactComponent as ProfessionalFishersIcon } from '@app/assets/admin-icons/professionalFishers_icon.svg';
import { ReactComponent as HuntingOperationsIcon } from '@app/assets/admin-icons/huntingOperations_icon.svg';
import { ReactComponent as AnalyticsIcon } from '@app/assets/admin-icons/analytics_icon.svg';
import { ReactComponent as UserManagementIcon } from '@app/assets/admin-icons/userManagement_icon.svg';
import referenceDataIcon from '@app/assets/icons/reference-data.png';
import { ReactComponent as ReportsIcon } from '@app/assets/admin-icons/reports_icon.svg';
import { ReactComponent as SettingsIcon } from '@app/assets/admin-icons/settings_icon.svg';
import {
  NATURAL_BREEDING_PATH,
  HOME_PATH,
  FISHING_INSPECTIONS_PATH,
  FISHING_OBSERVATIONS_PATH,
  FISH_TYPES_PATH,
  WATERBODIES_PATH,
  LICENSES_PATH,
  LICENSES_RETURN_PATH,
  FISHERS_PATH,
  SESSIONS_PATH,
  CATCHES_PATH,
  INVENTORY_PATH,
  STOCKING_PLAN_PATH,
  STOCKING_JOURNAL_PATH,
  STOCKING_YEARLY_SUMMARY_PATH,
  BREEDING_JOURNAL_PATH,
  IMPORT_PAPER_STATISTICS_PATH,
  FISH_MOVEMENT_PATH,
  DRAUGHTINESS_PATH,
  WATER_QUALITY_PATH,
  PROFESSIONAL_FISHER_PATH,
  ALL_PROFESSIONAL_FISHERS_PATH,
  HUNTERS_PATH,
  KILLS_PATH,
  HUNTING_INSPECTIONS_PATH,
  HUNTING_LICENSES_PATH,
  ANALYTICS_FISHING_OPERATIONS_PATH,
  ANALYTICS_FISHING_MANAGEMENT_PATH,
  ANALYTICS_FISHING_HABITAT_PATH,
  ANALYTICS_PROFESSIONAL_FISHERS_PATH,
  ANALYTICS_HUNTING_OPERATIONS_PATH,
  ANALYTICS_SUMMARY_PATH,
  ANALYTICS_BASIC_STATISTICS_PATH_PATH,
  ROLES_PATH,
  ORGANISATIONAL_UNITS_PATH,
  MESSAGES_PATH,
  ADMIN_USERS_PATH,
  WATERBODY_REGULATIONS_PATH,
  GEOGRAPHIC_AREAS_PATH,
  LICENSE_TYPES_PATH,
  NET_TYPES_PATH,
  FISHING_FEES_PATH,
  HUNTING_FEES_PATH,
  REPORTS_PATH,
  GENERAL_PATH,
  WORKFLOWS_PATH,
} from '@app/constants/routerPaths';
import { SidebarNavigationItem } from '@app/interfaces/sideNavigation';

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'common.home',
    key: 'home',
    url: HOME_PATH,
    icon: <HomeIcon />,
  },
  {
    title: 'common.fishingOperations',
    key: 'fishingOperations',
    icon: <FishingOperationsIcon style={{ fill: 'none' }} />,
    children: [
      { title: 'common.licenses', key: 'licenses', url: LICENSES_PATH },
      { title: 'common.licensesReturn', key: 'licensesReturn', url: LICENSES_RETURN_PATH },
      { title: 'common.fishers', key: 'fishers', url: FISHERS_PATH },
      { title: 'common.sessions', key: 'sessions', url: SESSIONS_PATH },
      { title: 'common.catches', key: 'catches', url: CATCHES_PATH },
      {
        title: 'common.inspections',
        key: 'inspections',
        url: FISHING_INSPECTIONS_PATH,
      },
      {
        title: 'common.paperStatistics',
        key: 'paperStatistics',
        url: IMPORT_PAPER_STATISTICS_PATH,
      },
    ],
  },
  {
    title: 'common.fishingManagement',
    key: 'fishingManagement',
    icon: <FishingManagementIcon />,
    children: [
      { title: 'common.inventory', key: 'inventory', url: INVENTORY_PATH },
      {
        title: 'common.naturalBreeding',
        key: 'naturalBreeding',
        url: NATURAL_BREEDING_PATH,
      },
      { title: 'common.stockingPlan', key: 'stockingPlan', url: STOCKING_PLAN_PATH },
      { title: 'common.stockingJournal', key: 'stockingJournal', url: STOCKING_JOURNAL_PATH },
      { title: 'common.stockingYearlySummary', key: 'stockingYearlySummary', url: STOCKING_YEARLY_SUMMARY_PATH },
      {
        title: 'common.breedingJournal',
        key: 'breedingJournal',
        url: BREEDING_JOURNAL_PATH,
      },
    ],
  },
  {
    title: 'common.fishingHabitat',
    key: 'fishingHabitat',
    icon: <FishingHabitatIcon style={{ fill: 'white', width: 22, height: 22 }} />,
    children: [
      { title: 'common.fishMovement', key: 'fishMovement', url: FISH_MOVEMENT_PATH },
      {
        title: 'common.observations',
        key: 'observations',
        url: FISHING_OBSERVATIONS_PATH,
      },
      { title: 'common.draughtiness', key: 'draughtiness', url: DRAUGHTINESS_PATH },
      { title: 'common.waterQuality', key: 'waterQuality', url: WATER_QUALITY_PATH },
    ],
  },
  {
    title: 'common.professionalFisher',
    key: 'professionalFisher',
    icon: <ProfessionalFishersIcon />,
    url: PROFESSIONAL_FISHER_PATH,
  },
  {
    title: 'common.professionalFishers',
    key: 'allProfessionalFishers',
    icon: <ProfessionalFishersIcon />,
    url: ALL_PROFESSIONAL_FISHERS_PATH,
  },
  {
    title: 'common.huntingOperations',
    key: 'huntingOperations',
    icon: <HuntingOperationsIcon />,
    children: [
      { title: 'common.hunters', key: 'hunters', url: HUNTERS_PATH },
      { title: 'common.games', key: 'kills', url: KILLS_PATH },
      { title: 'common.inspections', key: 'huntingInspections', url: HUNTING_INSPECTIONS_PATH },
      { title: 'common.huntingLicenses', key: 'huntingLicenses', url: HUNTING_LICENSES_PATH },
    ],
  },
  {
    title: 'common.analytics',
    key: 'analytics',
    icon: <AnalyticsIcon />,
    children: [
      {
        title: 'common.fishingOperations',
        key: 'analyticsFishingOperations',
        url: ANALYTICS_FISHING_OPERATIONS_PATH,
      },
      {
        title: 'common.fishingManagement',
        key: 'analyticsFishingManagement',
        url: ANALYTICS_FISHING_MANAGEMENT_PATH,
      },
      {
        title: 'common.fishingHabitat',
        key: 'analyticsFishingHabitat',
        url: ANALYTICS_FISHING_HABITAT_PATH,
      },
      {
        title: 'common.professionalFishers',
        key: 'analyticsProfessionalFishers',
        url: ANALYTICS_PROFESSIONAL_FISHERS_PATH,
      },
      {
        title: 'common.huntingOperations',
        key: 'analyticsHuntingOperations',
        url: ANALYTICS_HUNTING_OPERATIONS_PATH,
      },
      { title: 'common.summary', key: 'analyticsSummary', url: ANALYTICS_SUMMARY_PATH },
      {
        title: 'common.basicStatistics',
        key: 'analyticsBasicStatistics',
        url: ANALYTICS_BASIC_STATISTICS_PATH_PATH,
      },
    ],
  },
  {
    title: 'common.userManagement',
    key: 'userManagement',
    icon: <UserManagementIcon />,
    children: [
      { title: 'common.adminusers', key: 'adminUsers', url: ADMIN_USERS_PATH },
      { title: 'common.roles', key: 'roles', url: ROLES_PATH },
      { title: 'common.organisationalUnits', key: 'organisationalUnits', url: ORGANISATIONAL_UNITS_PATH },
      { title: 'common.messages', key: 'inboxMessages', url: MESSAGES_PATH },
      { title: 'common.adminusers', key: 'adminUsers', url: ADMIN_USERS_PATH },
    ],
  },
  {
    title: 'common.masterData',
    key: 'masterData',
    icon: <img src={referenceDataIcon} alt="" style={{ width: '1.25rem', height: '1.25rem', objectFit: 'contain' }} />,
    children: [
      { title: 'common.waterbodies', key: 'waterbodies', url: WATERBODIES_PATH },
      { title: 'common.waterbodyRegulations', key: 'waterbodyRegulations', url: WATERBODY_REGULATIONS_PATH },
      { title: 'common.geographicAreas', key: 'geographicAreas', url: GEOGRAPHIC_AREAS_PATH },
      { title: 'common.licenseType', key: 'licenseTypes', url: LICENSE_TYPES_PATH },
      { title: 'common.fishTypes', key: 'fishTypes', url: FISH_TYPES_PATH },
      { title: 'common.netTypes', key: 'netTypes', url: NET_TYPES_PATH },
      { title: 'common.fishingFees', key: 'fishingFees', url: FISHING_FEES_PATH },
      { title: 'common.huntingFees', key: 'huntingFees', url: HUNTING_FEES_PATH },
    ],
  },
  {
    title: 'common.reports',
    key: 'reports',
    icon: <ReportsIcon />,
    url: REPORTS_PATH,
  },
  {
    title: 'common.settings',
    key: 'settings',
    icon: <SettingsIcon />,
    children: [
      { title: 'common.general', key: 'generalSettings', url: GENERAL_PATH },
      { title: 'common.workflows', key: 'workflowsSettings', url: WORKFLOWS_PATH },
    ],
  },
];
